import React, { useState } from 'react';

export const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <div className="flex items-center flex-1 min-w-0">
            <h1 className="text-base sm:text-lg md:text-xl lg:text-2xl font-bold truncate" style={{ fontFamily: '"Agrandir Grand", sans-serif' }}>
              <a href="/" className="text-purple-600 hover:text-purple-700 transition-colors">GMX Estamparia Digital Fortaleza</a>
            </h1>
          </div>
          
          <nav className="hidden lg:flex items-center space-x-6 xl:space-x-8 ml-8">
            <a href="#sobre" className="text-gray-700 hover:text-purple-600 transition-colors cursor-pointer text-sm xl:text-base whitespace-nowrap font-medium">Sobre</a>
            <a href="#servicos" className="text-gray-700 hover:text-purple-600 transition-colors cursor-pointer text-sm xl:text-base whitespace-nowrap font-medium">Serviços</a>
            <a href="#depoimentos" className="text-gray-700 hover:text-purple-600 transition-colors cursor-pointer text-sm xl:text-base whitespace-nowrap font-medium">Depoimentos</a>
            <a href="#contato" className="text-gray-700 hover:text-purple-600 transition-colors cursor-pointer text-sm xl:text-base whitespace-nowrap font-medium">Contato</a>
          </nav>
          
          <button 
            className="lg:hidden p-2 ml-4 cursor-pointer hover:bg-gray-100 rounded-lg transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Menu"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}></i>
          </button>
        </div>
        
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-100">
            <nav className="flex flex-col space-y-3">
              <a href="#sobre" className="text-gray-700 hover:text-purple-600 transition-colors cursor-pointer py-2 px-2 rounded-lg hover:bg-gray-50 font-medium" onClick={() => setIsMenuOpen(false)}>Sobre</a>
              <a href="#servicos" className="text-gray-700 hover:text-purple-600 transition-colors cursor-pointer py-2 px-2 rounded-lg hover:bg-gray-50 font-medium" onClick={() => setIsMenuOpen(false)}>Serviços</a>
              <a href="#depoimentos" className="text-gray-700 hover:text-purple-600 transition-colors cursor-pointer py-2 px-2 rounded-lg hover:bg-gray-50 font-medium" onClick={() => setIsMenuOpen(false)}>Depoimentos</a>
              <a href="#contato" className="text-gray-700 hover:text-purple-600 transition-colors cursor-pointer py-2 px-2 rounded-lg hover:bg-gray-50 font-medium" onClick={() => setIsMenuOpen(false)}>Contato</a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
